import { createContext, useContext, useState, useEffect } from 'react'
import { useAuthState } from 'react-firebase-hooks/auth'
import { auth, db } from '../firebase'
import { doc, getDoc } from 'firebase/firestore'

// Create the context
const UserDataContext = createContext(null)

export const UserDataProvider = ({ children }) => {
  const [user] = useAuthState(auth)
  const [userData, setUserData] = useState(null)

  useEffect(() => {
    const fetchUserData = async () => {
      if (user) {
        try {
          const userRef = doc(db, 'users', user.uid)
          const userDoc = await getDoc(userRef)
          if (userDoc.exists()) {
            const data = { ...userDoc.data() }
            if (data.studentDocId && !data.role) data.role = 'student'
            setUserData({ ...data, ref: userDoc.ref })
          } else {
            console.error('No such user document!')
          }
        } catch (error) {
          console.error('Error fetching user document:', error)
        }
      }
    }

    fetchUserData()
  }, [user])

  // Provide the user data to the context
  return <UserDataContext.Provider value={userData}>{children}</UserDataContext.Provider>
}

// Hook to access the user data context
export const useUserDataContext = () => useContext(UserDataContext)
